import { CommandParser } from '../client/parser';
import { RedisArgument, ArrayReply, BlobStringReply, SetReply, Command } from '../RESP/types';

export default {
  parseCommand(parser: CommandParser, key: RedisArgument) {
    parser.push('SMEMBERS');
    parser.pushKey(key);
  },
  transformReply: {
    2: undefined as unknown as () => ArrayReply<BlobStringReply>,
    3: undefined as unknown as () => SetReply<BlobStringReply>
  }
} as const satisfies Command;
